module.exports = __webpack_public_path__ + "static/img/toritori-g.d849f397.png";